var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-info btn_nanosoft"},[_c('download-excel',{attrs:{"name":"تقرير كشف ضريبة الجهاد","stringifyLongNum":true,"fetch":_vm.fetchData,"fields":_vm.json_fields,"header":[
      _vm.name,
      _vm.desc,
      ("تقرير كشف ضريبة الجهاد من شهر " + (_vm.convert_Month(
        _vm.from
      )) + " الى شهر " + (_vm.convert_Month(_vm.to))) ]}},[_vm._v(" طباعة Excel ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }